module.exports = __webpack_public_path__ + "media/images/sk10-266401f059c5dd2fb740426767631836.svg";